import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/scss/bootstrap.scss';
import 'bootstrap/scss/bootstrap-grid.scss';
import 'bootstrap/scss/bootstrap-reboot.scss';
import 'bootstrap/scss/bootstrap-utilities.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import basename from "./basename.js";
import DelegateMarkdownLinks from "./DelegateMarkdownLinks.js";
import RegisterNewComplaint from './RegisterNewComplaint.js';
import CheckComplaintStatus from './CheckComplaintStatus.js';
import CheckStatus from './CheckStatus.js';
import InternalError from './InternalError';
import RestrictedContent from './RestrictedContent';
import reportWebVitals from './reportWebVitals';
const common = require('./common');

ReactDOM.render(
  <Router basename={basename}>
    <DelegateMarkdownLinks>
      <Switch>
        <Route path="/" exact={true} component={RegisterNewComplaint} />
        <Route path="/register-new-complaint" component={RegisterNewComplaint} />
        <Route path="/check-complaint-status" component={CheckComplaintStatus} />
        <Route path="/complaint-status" component={CheckStatus} />
        <Route path="/InternalError" component={InternalError} />
        <Route path="/RestrictedContent" component={RestrictedContent} />
      </Switch>
    </DelegateMarkdownLinks>
  </Router>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
